/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_RegenerateInputs */



/**
* | output |
* | --- |
* | "Make it again" |
*
* @param {Meeting_Prep_RegenerateInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_regenerate = /** @type {((inputs?: Meeting_Prep_RegenerateInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_RegenerateInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Opnieuw maken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Refaire")
	return /** @type {LocalizedString} */ ("Make it again")
});